import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { enumBillItemProductCode } from '@data-layer/enums/payments';
import { ProductModel } from '@data-layer/models/common';
import { ProductDetailsManagementModel } from '@data-layer/models/common/product-details-management-model';

@Injectable({ providedIn: 'root' })
export class ProductsRepository {
  constructor(private apiService: ApiService) {}

  // #13318 — the create-company page has no company yet: omitting companyId asks for the price
  // a company created now would be charged, resolved from organizationId (ignored when a
  // company is given). Both ids must be OMITTED rather than passed as undefined/0 — HttpParams
  // stringifies undefined into "undefined" (400) and 0 is not a valid id (404).
  public getProductsByCompany(
    productCode: enumBillItemProductCode,
    companyId: number | null,
    countryId?: number,
    organizationId?: number | null,
  ): Observable<ProductModel> {
    return this.apiService.get<ProductModel>(
      `${environment.url.prefixCustoms}v2/product-details`,
      {
        params: {
          productCode,
          ...(!!companyId && { companyId }),
          ...(!!organizationId && { organizationId }),
          ...(!!countryId && { countryId }),
        },
      },
      { isShowLoader: true },
    );
  }

  public getManagementProductsByCompany(
    productCode: enumBillItemProductCode,
    companyId: number,
    countryId?: number,
  ): Observable<ProductDetailsManagementModel> {
    return this.apiService.get<ProductDetailsManagementModel>(
      `${environment.url.prefixCustoms}v2/management/product-details/user-data`,
      { params: { productCode, companyId, ...(!!countryId && { countryId }) } },
      { isShowLoader: true },
    );
  }
}
